<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="Category2" prop="category2CodesList">
                <el-select v-model="queryCondition.category2CodesList" @change="changeCategory2" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                  <el-option v-for="item in categoryList2" :label="item.name" :value="item.code" :key="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Category3" prop="category3CodesList">
                <el-select v-model="queryCondition.category3CodesList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="月" prop="monthList">
                <el-select v-model="queryCondition.monthList" clearable multiple placeholder="请选择(支持多选)" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in monthOptions" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Facility名称" prop="facilityName">
                <el-input v-model="queryCondition.facilityName" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onExport">导出</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" max-height="500" show-overflow="tooltip" highlight-current-row>
        <!-- <ux-table-column align="center" title="序号" type="index" width="60" /> -->
        <ux-table-column align="center" title="Category3" field="category3Name"></ux-table-column>
        <ux-table-column align="center" title="月" field="month"></ux-table-column>
        <ux-table-column align="center" title="Facility编号" field="facilityCode"></ux-table-column>
        <ux-table-column align="center" title="Facility名称" field="facilityName"></ux-table-column>
        <ux-table-column align="center" title="DC发货量" field="outbound"></ux-table-column>
        <ux-table-column align="center" title="更新时间" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import dcOutbound from "@/api/dCOutbound";
import DQMPApi from "@/api/DQMP/index";


export default {
  name: '',
  components: {
    IcSelect,
  },
  data() {
    return {
      monthOptions:[],
      showGcDialog: false,
      queryCondition: {
        pageNum:1,
        pageSize:15,
        category2CodesList: [],
        category3CodesList: [],
        monthList:[],
        facilityName:""
      },
      categoryList2: [],
      categoryList3: [],
      tableData: [],
      totalCount:0,
      tmCategoryId:"",
      pidList:[],
      newArr:[],
    }
  },
  created() {
    this.getMonth()
    this.queryData();
    this.getCategory1Lists()
  },
  methods: {
    queryData(val) {
      if(undefined != val){
        this.queryCondition.pageNum=1
      }
      dcOutbound.dcOutboundList(this.queryCondition).then((res)=>{
        this.tableData=res.resultData
        this.totalCount = res.totalCount;
      })
    },
    getCategory1Lists(){
      var param = {
        code: '10',
      }
      dcOutbound.findCategory(param).then(res => {
        this.tmCategoryId=res.data[0].tmCategoryId
        this.getCategory2Lists(res.data[0].tmCategoryId)
      });
    },
    getCategory2Lists(val) {
      var param = {
        categoryLevel: '2',
        pid:val
      }
      dcOutbound.findCategory(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    getMonth() {
      DQMPApi.getMonth().then(res => {
        this.monthOptions = res
      })
    },
    // getCategory3Lists() {
    //   var param = {
    //     categoryLevel: '3',
    //     pid:this.tmCategoryId
    //   }
    //   dcOutbound.findCategory(param).then(res => {
    //     this.categoryList3 = res.data
    //   });
    // },
    //根据选中Category2查询Category3
    changeCategory2(val) {
      this.pidList=[]
      let arr=this.categoryList2.filter((a)=>{
        return val.indexOf(a.code)!=-1
      })
      arr.forEach((v)=>{
        this.pidList.push(v.tmCategoryId)
      })
      let setPidList=new Set(this.pidList)
      this.categoryList3 = []
      dcOutbound.findCategory({ categoryLevel: 3, pidList: setPidList }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageNum:1,
        pageSize:15,
        category2CodesList: [],
        category3CodesList: [],
        monthList:[],
        facilityName:""
      }
      this.categoryList3=[]
      this.queryData();
    },
    onExport() {
      dcOutbound.dataListDownload(this.queryCondition)
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  },
}
</script>
<style scoped >
</style>
